<div class="bg">
    <div class="container h-100">
        <div class="row h-100 justify-content-center align-items-center">
            <div class="panel panel-primary panel-transparent col-10 col-sm-8 col-md-6 col-lg-4">
                <div class="panel-body p-3 text-center">
                    <img src="assets/img/austrotherm.png" class="img-fluid mx-auto d-block pt-3" alt="Austrotherm">
                    <div class="pt-2">
                        <h1>Projektverwaltung</h1>
                    </div>
                    <div class="pb-3">
                        <router-outlet/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

